/* eslint-disable max-len */
import { Divider, Switch, IconButton, Tooltip, Typography, Box, FormHelperText } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate, createSearchParams, useSearchParams } from 'react-router-dom';
import { FieldControllerTypes } from '../../components/form_v2/types';
import TableGridWithFilters from '../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import Theme from '../../Themes/main.theme';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import HttpService from '../../services/HttpService';
import { createSearchParamsFormat, maxValidationString } from '../../lib/helperFuncs';
import DialogAction from '../../components/Dialog/DialogAction';
import { useSnackbar } from 'notistack';
import { ISortingFilters } from '../../components/Tag/types';
import { Ilevels } from '../../lib/generalTypes';
import * as Yup from 'yup';
import Sorting from '../../components/Sorting/Sorting';
import EditIcon from '@mui/icons-material/Edit';
import LaunchIcon from '@mui/icons-material/Launch';
import AsyncBackdropSubmit from '../../components/AsyncBackdropSubmit';
import UserService from '../../services/UserService';
import { Permissions, PermissionsManageLocProf } from '../../lib/permissions';

const initialValues = {
  free_text: '',
  regions: '',
  level2: '',
};

const validationSchema = Yup.object({
  free_text:
    Yup.string().max(60, maxValidationString(60)),
});


const LocationsDashboard = () => {
  document.title = 'Διαχείριση Τοποθεσιών';

  const [level2Options, setlevel2Options] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [regions, setRegions] = useState([]);
  const [forceReFetch, setForceReFetch] = useState<boolean>(false);
  const [status, setStatus] = useState({ id: null, is_published: false });
  const [sortBy, setSortBy] = useState<ISortingFilters | undefined>({
    id: '1',
    refValue: 'title',
    sortOrder: 'asc',
    label: 'Τίτλος Τοποθεσίας'
  });
  const [onChangeLoading, setOnChangeLoading] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const sortingItems: ISortingFilters[] | undefined = [{
    id: '1',
    refValue: 'title',
    sortOrder: 'asc',
    label: t('Τίτλος Τοποθεσίας')
  }, {
    id: '2',
    refValue: 'locations:CategoriesLvl2',
    sortOrder: 'asc',
    label: t('Κατηγορία Τοποθεσίας'),
  }];

  const handleSortingChange = (sortingItemId: string) => {
    const newSort = sortingItems.find(x => x.id == sortingItemId);
    setSortBy(newSort);
  };

  const onChangeLocation = async (id: number | null) => {
    setOnChangeLoading(true);
    try {
      const resp = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/locations/${id}`, {
        is_published: status.is_published
      });
      if (resp.status === 200) {
        enqueueSnackbar('Επιτυχής αλλαγή κατάστασης της τοποθεσίας', { variant: 'success' });
        setForceReFetch(!forceReFetch);
      }
      setOnChangeLoading(false);
    } catch (error) {
      console.error(error);
      setOnChangeLoading(false);
      enqueueSnackbar('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.', { variant: 'error' });
    }
  };

  const isSwitchEnabled = (row: any) => {
    {
      if (UserService.hasRole([PermissionsManageLocProf.PermissionInternalManagePublishLocationCreateAll])) {
        return true;
      }
      if (UserService.hasRole([PermissionsManageLocProf.PermissionInternalManagePublishLocationCreateMyOrg])) {
        return row.isUserInTheOfficeOfTheLocation === true;
      }
      return false;
    }
  };

  const filterFields = (
    regions: Ilevels[],
    level2Options: Ilevels[],
  ) => {
    return [
      [{
        control: FieldControllerTypes.input,
        type: 'text',
        customLabel: true,
        name: 'free_text',
        label: t('Τίτλος Τοποθεσίας'),
        filtersDesign: true
      },
      {
        control: FieldControllerTypes.autocomplete,
        type: 'autocomplete',
        label: t('Film Office που Ανήκει'),
        name: 'regions',
        filtersDesign: true,
        options: regions
      },
      {
        control: FieldControllerTypes.autocomplete,
        type: 'autocomplete',
        label: t('Κατηγορία Τοποθεσίας'),
        name: 'level2',
        filtersDesign: true,
        options: level2Options,
      }
      ]
    ];
  };

  const columns: GridColDef[] = [
    {
      field: 'dcterms:title',
      headerName: 'Τίτλος τοποθεσίας',
      minWidth: 350,
      sortable: false,
      renderCell: ({ row }) => row?.['dcterms:title']?.[0]?.['@value']
    },
    {
      field: 'administrative_unit',
      headerName: 'Film Office',
      minWidth: 300,
      sortable: false,
      // renderCell: ({row}) =>row?.['locations:Film Offices']?.[0]?.['display_title']
    },
    {
      field: 'locations:CategoriesLvl2',
      headerName: 'Κατηγορία Τοποθεσίας',
      minWidth: 260,
      sortable: false,
      renderCell: ({ row }) => row?.['locations:CategoriesLvl2']?.map((x: any) => x?.['display_title']).sort(
        (a: any, b: any) => a.localeCompare(b)
      ).join(', ') || '-'
    },
    {
      field: 'action',
      headerName: 'Ενέργειες',
      minWidth: 150,
      sortable: false,
      renderCell: ({ row }) => <>
        <Tooltip PopperProps={{
          disablePortal: true
        }}
        title='Επεξεργασία'>
          <IconButton
            disabled={
              UserService.hasRole([Permissions.PermissionInternalLocationApplicationModificationRequestCreateMy_org]) &&
              !UserService.hasRole([Permissions.PermissionInternalLocationApplicationModificationRequestCreateAll]) &&
              row.isUserInTheOfficeOfTheLocation !== true
            }
            sx={{ mr: 1 }}
            color='primary'
            onClick={() => navigate(`/admin/locations/edit/${row['o:id']}?omeka=true`)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip PopperProps={{
          disablePortal: true
        }}
        title='Προβολή'>
          <IconButton sx={{ mr: 1 }}
            color='primary'
            onClick={() => navigate(`/admin/locations/details/${row['o:id']}`)}>
            <LaunchIcon /></IconButton>
        </Tooltip>
      </>
    },
    {
      field: 'isPublished',
      headerName: 'Publish / Unpublish',
      sortable: false,
      flex: 1,
      renderCell: ({ row }) =>
        <Switch
          checked={row['o:is_public']}
          disabled={!isSwitchEnabled(row)}
          //     Location_status_Dictionary[Location_status.Published] === row['o:is_public'] ||
          // Location_status_Dictionary[Location_status.Unpublished] === row['o:is_public']
          // }
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
            setStatus({
              id: row['o:id'],
              is_published: !row['o:is_public']
            });
          }} />
    }
  ];

  const onSubmit = (values: any) => {
    const x = createSearchParamsFormat(values);
    Object.keys(initialValues).map((value) => {
      searchParams.delete(value);
      setSearchParams(searchParams);
    });
    setSearchParams(`${searchParams.toString()}&${createSearchParams(x).toString()}`);
  };

  useEffect(() => {
    const getRegions = async () => {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/regions-search`);
      const options = resp?.data['o:terms'].map((location: any) => {
        return {
          key: t(location.key),
          value: location.value
        };
      });
      setRegions(options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
    };

    const getLevel2Options = async () => {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level2`);
      const options = resp?.data?.data?.map((location: any) => {
        const x = location?.['dcterms:relation'];
        if (!x) return;
        return {
          key: location?.['o:title'],
          value: location?.['o:id'],
          parent: x[0].display_title
        };
      }).filter((value: any) => value);
      setlevel2Options(options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
    };

    Promise.all([
      getLevel2Options(),
      getRegions()
    ]);
  }, []);

  useEffect(() => {
    setForceReFetch(!forceReFetch);
  }, [sortBy]);

  return (
    <>
      <AsyncBackdropSubmit isLoading={onChangeLoading}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <Typography sx={{ my: 2, mt: 4 }} variant='h2'
        color={Theme?.labelColor?.main}>{t('Διαχείριση Τοποθεσιών')}</Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />

      <TableGridWithFilters
        componentInBetween={
          <>
            <Box sx={{ mt: 4 }}>
              <Sorting defaultValue={sortBy?.id} onChange={(value) => handleSortingChange(value)}
                sortingItems={sortingItems} />
              <FormHelperText>
                <Typography
                  variant='body1'
                  textAlign='center'
                  fontStyle='italic'
                  sx={{
                    fontWeight: 'bolder',
                  }}
                >
                  Κατά την <u> επαναδημοσίευση</u> τοποθεσιών,
                  η διαδικασία θα ολοκληρωθεί άμεσα,
                  αλλά η δημοσίευση ενδέχεται να διαρκέσει μερικά λεπτά.
                </Typography>
              </FormHelperText>
            </Box>
          </>
        }
        pageSize={15}
        rowsPerPageOptions={[15, 30, 45]}
        sortingMode='server'
        reFetch={forceReFetch}
        responseDataFieldName='records'
        responseTotalCountFieldName='totalResults'
        paginationMode='server'
        changeFilters={(values: any) => onSubmit(values)}
        initialValues={initialValues}
        filterFields={filterFields(regions, level2Options)}
        validationSchema={validationSchema}
        columns={columns}
        resetFilters={true}
        fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/locations/my-org?sort_by=${sortBy?.refValue}&sort_order=asc`} />
      <DialogAction
        open={open} title={'Αλλαγή Κατάστασης'}
        handleClose={() => {
          setOpen(false);
        }}
        content='Είστε σίγουρος/η ότι θέλετε να αλλάξετε την κατάσταση;'
        onAccept={() => {
          onChangeLocation(status.id);
          setOpen(false);
        }} />
    </>
  );
};

export default LocationsDashboard;